const errors = {
  "error.default.retry.title": "Ups, algo salió mal...",
  "error.default.retry.message": "Puede haber un problema con tu conexión, verifica tu conexión y haz clic en reintentar.",

  "error.default.logout.title": "Ups, algo salió mal...",
  "error.default.logout.message": "Necesitarás cerrar sesión para solucionar este problema.",

  "error.default.message_only.title": "Ups, algo salió mal...",
  "error.default.message_only.message": "Necesitarás iniciar sesión nuevamente",

  "error.default.go_back.title": "Ups, algo salió mal...",
  "error.default.go_back.message": "Ocurrió un problema con la acción actual.",

  "error.default.reset.title": "Ups, algo salió mal...",
  "error.default.reset.message": "Necesitarás iniciar sesión nuevamente",

  "error.feature.available-on-mobile.title": "Por favor, usa la aplicación móvil",
  "error.feature.available-on-mobile.message": "Esta función no está disponible en este momento, por favor usa la aplicación móvil.",
};

export default errors;
